import strings from 'strings';

/**
 * Copies text using the legacy `execCommand` fallback for environments where the
 * Clipboard API is unavailable or rejects.
 * @param {string} text
 */
const fallbackCopy = text => {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const succeeded = document.execCommand('copy');
    if (!succeeded) {
      throw new Error(strings.shared.ui.copyToClipboardFailed);
    }
  } finally {
    document.body.removeChild(textArea);
  }
};

/**
 * Copies text to the clipboard using the Clipboard API with an execCommand fallback.
 * @param {string} text
 * @returns {Promise<void>}
 */
export const copyToClipboard = async text => {
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // Clipboard API can reject (permission denied / insecure context) — try the fallback below
    }
  }

  fallbackCopy(text);
};
